
export type Option = {
  label: string
  value: string | number
  item?: any
}

export const getLableByValue = (value: string | number, options: Option[]) => {
  if(!Array.isArray(options)) {
    return
  }
  const option = options.find(item => item.value === value)
  if(!option) {
    return ''
  }
  return option.label
}

export const gztLyOptions = [
  { label: '项目', value: '项目' },
  { label: '非项目', value: '非项目' },
]

export const jeOptions = [
  { value: '0', label: '全部' },
  { value: '1', label: '0-50万元', filter: (data) => data < 50 && data >= 0 },
  { value: '2', label: '0-100万元', filter: (data) => data < 100 && data >= 0 },
  { value: '3', label: '100万元-500万元', filter: (data) => data < 500 && data >= 100 },
  { value: '4', label: '100万元以上', filter: (data) => data >= 100 },
  { value: '5', label: '500万元以上', filter: (data) => data >= 500 },
]

export const approveModelOptions = [
  { label: '教育培训申请', value: '教育培训申请' },
  { label: '评审登记单', value: '评审登记单' },
  { label: '审计登记单', value: '审计登记单' },
  { label: '举办会议申请', value: '举办会议申请' },
  { label: '参加会议申请', value: '参加会议申请' },
  { label: '差旅申请单', value: '差旅申请单' },
  { label: '办公自动化申购', value: '办公自动化申购' },
  { label: '电脑网络设备申购', value: '电脑网络设备申购' },
  { label: '办公家具申购', value: '办公家具申购' },
  { label: '空调家电申购', value: '空调家电申购' },
  { label: '常规服务采购', value: '常规服务采购' },
  { label: '常规产品采购', value: '常规产品采购' },
  { label: '实验耗材合同', value: '实验耗材合同' },
  { label: '评审合同', value: '评审合同' },
  { label: '审计合同', value: '审计合同' },
  { label: '举办会议合同', value: '举办会议合同' },
  { label: '参加会议合同', value: '参加会议合同' },
  { label: '教育培训合同', value: '教育培训合同' },
  { label: '公务办理', value: '公务办理' },
  { label: '电脑网络报销', value: '电脑网络报销' },
  { label: '差旅报销', value: '差旅报销' },
  { label: '劳务配合报销', value: '劳务配合报销' },
  { label: '咨询设计报销', value: '咨询设计报销' },
  { label: '工程耗材报销', value: '工程耗材报销' },
  { label: '检测外包报销', value: '检测外包报销' },
  { label: '常规报销（现金）', value: '常规报销（现金）' },
  { label: '常规报销（公对公）', value: '常规报销（公对公）' },
  { label: '预付款（不进）', value: '预付款（不进）' },
  { label: '预付款（汇）', value: '预付款（汇）' },
  { label: '标准工作餐', value: '标准工作餐' },
  { label: '误餐费', value: '误餐费' },
  { label: '定点餐饮', value: '定点餐饮' },
  { label: '其他公务接待', value: '其他公务接待' },
  { label: '商务接待费报销(新)', value: '商务接待费报销(新)' },
  { label: '投标保证金申请', value: '投标保证金申请' },
  { label: '参加会议费报销', value: '参加会议费报销' },
  { label: '举办会议费报销', value: '举办会议费报销' },
  { label: '教育培训费报销', value: '教育培训费报销' },
  { label: '评审费报销', value: '评审费报销' },
  { label: '审计费报销', value: '审计费报销' },
  { label: '酒水申购单', value: '酒水申购单' },
  { label: '酒水采购合同', value: '酒水采购合同' },
  { label: '酒水采购报销', value: '酒水采购报销' },
  { label: '酒水申领', value: '酒水申领' },
  { label: '其他费用报销申请', value: '其他费用报销申请' },
  { label: '仪器设备意向申购', value: '仪器设备意向申购' },
  { label: '发起采购（盖章）', value: '发起采购（盖章）' },
  { label: '仪器设备采购支付（非固定资产）', value: '仪器设备采购支付（非固定资产）' },
  { label: '仪器设备采购支付（固定资产）', value: '仪器设备采购支付（固定资产）' },
  { label: '仪器设备验收', value: '仪器设备验收' },
  { label: '维保意向申请单', value: '维保意向申请单' },
  { label: '维保合同', value: '维保合同' },
  { label: '维保报销', value: '维保报销' },
  { label: '仪器设备使用状态变更', value: '仪器设备使用状态变更' },
  { label: '地基基础结算申请', value: '地基基础结算申请' },
  { label: '地基基础付款申请', value: '地基基础付款申请' },
  { label: '地基基础劳务费报销', value: '地基基础劳务费报销' },
  { label: '投标报名盖章申请', value: '投标报名盖章申请' },
  { label: '投标文件盖章申请', value: '投标文件盖章申请' },
  { label: '方案报价盖章申请', value: '方案报价盖章申请' },
  { label: '待审核业务合同', value: '待审核业务合同' },
  { label: '补充协议盖章申请', value: '补充协议盖章申请' },
  { label: '外协合同申请', value: '外协合同申请' },
  { label: '外协费结算申请', value: '外协费结算申请' },
  { label: '外协费付款申请', value: '外协费付款申请' },
  { label: '外协费合同报销申请', value: '外协费合同报销申请' },
  { label: '法务文件盖章申请', value: '法务文件盖章申请' },
  { label: '其他技术文件盖章申请', value: '其他技术文件盖章申请' },
  { label: '其他商务文件盖章申请', value: '其他商务文件盖章申请' },
  { label: '结算付款申请书盖章申请', value: '结算付款申请书盖章申请' },
  { label: '竣工确认证明盖章申请', value: '竣工确认证明盖章申请' },
  { label: '个人评审', value: '个人评审' },
  { label: '私车公用', value: '私车公用' },
]
